import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { useAuth } from "../hooks";

// Creamos el contexto
const CompanyContext = createContext();

// Proveedor del contexto
export const CompanyProvider = (props) => {
  const { children } = props;
  const { user } = useAuth();
  const [company, setCompany] = useState(() => {
    const storedCompany = localStorage.getItem("company");
    return storedCompany ? storedCompany : "";
  });

  const hadUser = useRef(false);

  const changeCompany = (newCompany) => {
    setCompany(newCompany);
  };

  useEffect(() => {
    localStorage.setItem("company", company);
  }, [company]);

  useEffect(() => {
    if (!user) {
      // Solo limpiar si ya hubo un usuario (logout real), no en la carga inicial
      if (hadUser.current) {
        setCompany("");
      }
    } else {
      hadUser.current = true;
      const storedCompany = localStorage.getItem("company");
      setCompany(storedCompany || "");
    }
  }, [user]);

  return (
    <CompanyContext.Provider value={{ company, changeCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};

// Hook personalizado para consumir el contexto
export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompany debe ser usado dentro de un CompanyProvider");
  }
  return context;
};
